module.exports = __webpack_public_path__ + "static/media/aron_rodgers.44f63f6f.jpg";